import request from '@/utils/request'
import { method } from '@/utils/constant'

const { POST, GET } = method

export default {
  async getMemberserviceList(params) {
    return request({ method: POST, url: `/admin/approval/list`, params })
  },
  async getFilterTypeList(params) {
    return request({ method: GET, url: `/admin/approval/listQueryCondition` })
  },
  // 获取分会用户信息
  async getBranchInfo(params) {
    return request({ method: GET, url: `/admin/member/user/${params.id}` })
  },
  // 分会审批进度查询
  async getBranchApprovals(params) {
    return request({ method: GET, url: `/admin/approval/getApprovalProgress/${params.id}` })
  },
  // 审批操作
  async getApprovalOperate(params) {
    return request({ method: POST, url: `/admin/approval/operate`, params })
  },
  // 批复
  async replyLicense(params) {
    return request({ method: POST, url: `/admin/approval/replyLicense`, params })
  },
  // 新会员发证
  async getListMakeCert(params) {
    return request({ method: POST, url: `/admin/approval/listMakeCert`, params })
  },
  // 旧会员发证
  async changeCert(params) {
    return request({ method: POST, url: `/admin/background/member/changeCert`, params })
  },
  // 获取省
  async getProvince() {
    return request({ method: GET, url: `/admin/region/province` })
  },
  // 获取市
  async getCity(params) {
    return request({ method: GET, url: `/admin/region/city/${params.id}` })
  },
  // 获取区
  async getArea(params) {
    return request({ method: GET, url: `/admin/region/area/${params.id}` })
  },
  // 审批列表导出excel
  async exportApprovalList(params) {
    return request({
      method: POST,
      url: `/admin/approval/exportApprovalList`,
      responseType: 'blob',
      params,
    })
  },
  // 批量导出制证
  async exportMakeCert(params) {
    return request({
      method: POST,
      url: `/admin/approval/exportMakeCert`,
      responseType: 'blob',
      params,
    })
  },
  // 批量审核
  async approvalMemUsers(params) {
    return request({ method: POST, url: `/admin/approval/approvalMemUsers`, params })
  },
  // 批量批复
  async replyMemUsers(params) {
    return request({ method: POST, url: `/admin/approval/replyMemUsers`, params })
  },
  // 批量缴费确认
  async payConfirmMemUsers(params) {
    return request({ method: POST, url: `/admin/approval/payConfirmMemUsers`, params })
  },
  // 缴费详情
  async getPaymenList(params) {
    return request({ method: POST, url: `/admin/approval/payment/list`, params })
  },
  // 获取当前年度
  async getCurrentYear(params) {
    return request({ method: GET, url: `/admin/approval/getCurrentYear`, params })
  },
  // 老会员缴费确认
  async oldMemberPaymentConfirm(params) {
    return request({ method: POST, url: `/admin/background/member/paymentConfirm`, params })
  },
  // 修改会员信息
  async updateMemberInfo(params) {
    return request({ method: POST, url: `/admin/background/member/update`, params })
  },
  //不良记录登记
  async changeBadRecord(params) {
    return request({ method: POST, url: `/admin/approval/changeBadRecord`, params })
  },
  async getMemberChangeDetail(id) {
    return request({ method: GET, url: `/admin/background/memberChange/detail/${id}` })
  },

  // 新做发证相关
  // content后台写死，不再需要前端传了
  async makeMemberCard(_content, startTime, memberUserIdList, hasChangeCard) {
    return request({
      method: POST,
      url: '/admin/member/makeMemberCard',
      params: { startTime, memberUserIdList, hasChangeCard },
    })
  },

  async selectMemberCardLog(id) {
    return request({
      method: GET,
      url: '/admin/member/selectMemberCardLog/' + id,
    })
  },

  async exportReplyList(params) {
    return request({
      method: POST,
      url: `/admin/approval/exportReplyList`,
      responseType: 'blob',
      params,
    })
  },

  async exportPublishCardList(params) {
    return request({
      method: POST,
      url: `/admin/approval/exportPublishCardList`,
      responseType: 'blob',
      params,
    })
  },

  async updateMemberUserPayment(params) {
    return request({
      method: POST,
      url: `/admin/approval/updateMemberUserPayment`,
      params,
    })
  },

  async getReplySuccessInfo(id) {
    return request({
      method: GET,
      url: '/admin/member/getReplySuccessInfo/' + id,
    })
  },

  async deleteMemberUser(ids) {
    return request({
      method: POST,
      url: `/admin/background/member/deleteMemberUser`,
      params: ids,
    })
  },

  async selectMemberUserOfDelete(enterpriseName, enterpriseType, pageNo) {
    return request({
      method: POST,
      url: `/admin/background/member/selectMemberUserOfDelete`,
      params: {
        enterpriseName,
        enterpriseType,
        pageNo,
        sort: [{ asc: false, field: 'create_time' }],
      },
    })
  },

  async removeMemberUserOfDelete(ids) {
    return request({
      method: POST,
      url: `/admin/background/member/removeMemberUserOfDelete`,
      params: ids,
    })
  },

  async exportMemberUserOfDelete(enterpriseName, enterpriseType, fieldNameList) {
    return request({
      method: POST,
      url: `/admin/background/member/exportMemberUserOfDelete`,
      responseType: 'blob',
      params: {
        enterpriseName,
        enterpriseType,
        fieldNameList,
        sort: [{ asc: false, field: 'create_time' }],
      },
    })
  },

  async addTrainCertificate(memberTrainCertificateEntity) {
    return request({
      method: POST,
      url: `/admin/member/train/certificate/addTrainCertificate`,
      params: memberTrainCertificateEntity,
    })
  },

  async certList(searchEntity) {
    return request({
      method: POST,
      url: `/admin/member/train/certificate/list`,
      params: searchEntity,
    })
  },

  async updateTrainCertificate(memberTrainCertificateEntity) {
    return request({
      method: POST,
      url: `/admin/member/train/certificate/updateTrainCertificate`,
      params: memberTrainCertificateEntity,
    })
  },

  async deleteTrainCertificate(id) {
    return request({
      method: GET,
      url: `/admin/member/train/certificate/deleteTrainCertificate/${id}`,
    })
  },

  async batchDeleteTrainCertificate(ids) {
    return request({
      method: POST,
      url: `/admin/member/train/certificate/batchDeleteTrainCertificate`,
      params: ids,
    })
  },

  async searchTrainCertificateByCode(params) {
    return request({
      method: POST,
      url: `/admin/member/train/certificate/searchTrainCertificateByCode`,
      params,
    })
  },
}
